import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

import { FontData } from '@/static/fonts'


export default /*#__PURE__*/_defineComponent({
  __name: 'FontSelector',
  props: {
    fonts: null,
    selectedFont: null,
    disabled: { type: Boolean }
  },
  emits: ["fontSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fontSelected', fontName: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  fonts: FontData[],
  selectedFont: string | null,
  disabled: boolean
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['font-selector', { 'font-selector--disabled': __props.disabled }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fonts, ({ name, icon }, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['font-selector__item', { 'font-selector__item--selected': __props.selectedFont === name }]),
        onClick: ($event: any) => (emits('fontSelected', name))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(icon), { class: "font-selector__icon" }))
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})